"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISCORD_JEPGINEER_ROLE_ID = exports.PLACEHOLDER_CONTENT_DESCRIPTION = void 0;
exports.PLACEHOLDER_CONTENT_DESCRIPTION = 'Description TBD';
exports.DISCORD_JEPGINEER_ROLE_ID = '836003294978506832';
//# sourceMappingURL=consts.js.map